import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_111_labour_others: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "119",
      action: "modulev1/labour_others_add",
    },
    title: "Labour / Others",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "item_name",
            Name: "labour_summary",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/labour_others_add/<id>",
                },
                ActionType: "Edit",
                ScreenId: "119",
              },
              {
                Action: {
                  Action: "Delete",
                  Module: "item_master_summary",
                },
                ActionType: "Delete",
                ScreenId: "119",
              },
            ],
            Form: {
              Name: "labour_summary",
              TableName: "item_master",
              Filter:
                "item_group_1.id<>2 AND item_master.transaction_branch_id = '<branch_id>'",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Part No.",
                  IsMandatory: true,
                  BindValue: "txt_parts",
                  Json_Attribute: "part_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Item group",
                  BindValue: "drp_group",
                  Json_Attribute: "parent_id",
                  componentType: ComponentType.SELECT_DROPDOWN,
                  showInSummary: true,
                  LookupName: "labour_others",
                },
                {
                  IncludeLabel: true,
                  Label: "Item name",
                  IsMandatory: true,
                  BindValue: "txt_itemname",
                  Json_Attribute: "item_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
